// extracted by css-extract-rspack-plugin
export default {"Label":"e1_B5","InstanceLimitInputWrapper":"bCtm7","InputDescription":"CXXOQ","InputUnitSection":"chiY1"};